module.exports = __webpack_public_path__ + "img/IMG_Picto_MamiteOmbre.c3d33012.png";